import React from 'react'
import PropTypes from 'prop-types'

function PaymentSummary({league, type}) {
  const forTeam = type == 'team'
  const price = forTeam ? league.team_price : league.individual_price
  const currencyName = league.currency == 'usd' ? '' : ` (${league.currency.toUpperCase()})`

  return <div className='payment-summary'>
    <div className='payment-summary__content'>
      <div className='summary-row'>        
        <span>Registration Type</span>
        <span>{forTeam ? 'Team' : 'Free Agent'}</span>
      </div>
      <div className='summary-row'>
        <span>{`Registration Cost${currencyName}`}</span>
        <span>${parseFloat(price).toFixed(2)}</span>
      </div>
      <div className='summary-row summary-total'>
        <span>{`Total${currencyName}`}</span>
        <span>${parseFloat(price).toFixed(2)}</span>
      </div>
    </div>
  </div>
}

PaymentSummary.propTypes = {
  league: PropTypes.object.isRequired,
  type: PropTypes.string.isRequired,
}

export default PaymentSummary
